import { isRichTextTokenCountOver } from '@/lib/richTextHelper';

interface PasteEventOptions {
  top: boolean;
}

// 貼り付けの取り消しに使う Jodit の機能
export interface PasteLimitEditor<Snapshot> {
  readonly value: string;
  events: {
    // options は Jodit の on と同じく省略できる。top: true で既存のハンドラより先に呼ばれる
    on(eventName: string, callback: () => void, options?: PasteEventOptions): PasteLimitEditor<Snapshot>['events'];
  };
  history: {
    snapshot: {
      make(): Snapshot;
      restore(snapshot: Snapshot): void;
    };
  };
}

// Jodit の limitChars は空白・改行を数えないため、空白の多い内容を貼り付けるとトークン数が上限を超える
// 貼り付け後のトークン数が上限を超えたら、Jodit の limitChars と同じく貼り付けを丸ごと取り消す
export function cancelPasteOverTokenLimit<Snapshot>(
  editor: PasteLimitEditor<Snapshot>,
  getMaxTokenCount: () => number,
): void {
  let snapshotBeforePaste: Snapshot | null = null;

  editor.events
    .on('paste', () => {
      snapshotBeforePaste = editor.history.snapshot.make();
    }, { top: true })
    .on('afterPaste', () => {
      // 前回の貼り付けで控えた内容に戻さないよう、控えは1回の貼り付けにつき1度だけ使う
      const snapshot = snapshotBeforePaste;
      snapshotBeforePaste = null;
      if (snapshot === null) return;
      if (!isRichTextTokenCountOver(editor.value, getMaxTokenCount())) return;

      editor.history.snapshot.restore(snapshot);
    });
}
